<template>
    <div class="row">
        <div class="col-xl-12">
            <h4 class="mt-0 mb-1">Profile</h4>
            <profile-form :loading="loading" :user="user" @submit="editProfile"></profile-form>
        </div>
    </div>
</template>
<script>
import ProfileForm from 'Shared/Forms/ProfileForm'
export default {
    components: {
        ProfileForm
    },
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        async editProfile(values) {
            this.loading = true
            try {
                const val = Object.assign({}, { ...values })
                if (values.email !== this.user.email) {
                    val.changeEmail = true
                }
                await this.$store.dispatch('auth/UPDATE_PROFILE', val)
                this.$notify({
                    icon: 'nc-icon nc-check-2',
                    message: 'Profile was successfully updated.',
                    type: 'success',
                    horizontalAlign: 'center',
                    verticalAlign: 'bottom'
                })
            } catch (err) {
                this.$notify({
                    icon: 'nc-icon nc-simple-remove',
                    message: err.message,
                    type: 'danger',
                    horizontalAlign: 'center',
                    verticalAlign: 'bottom',
                    timeout: 0
                })
            } finally {
                this.loading = false
            }
        }
    }
}
</script>
